import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [ 'target' ]

  update({ target }) {
    this.targetTarget.innerHTML = target.value
  }
}
